// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__N-3Dz","tab":"ProcedureTabs_tab__2TqzI"};